export default __webpack_public_path__ + "static/summer_containers67-da504d49da6d7338cebaf80672fb3eed.webp";